import { useState } from 'hooks'
import * as M from 'materialize-css'

import { getDatePickerComponents } from './selector'

type State = {
	dateInputs: NodeListOf<HTMLInputElement>
}

export const DatePicker = (() => {
	const { state, setState } = useState<State>()

	const initDates = () => {
		const { dateInputs } = state

		if (dateInputs.length === 0) {
			return
		}

		dateInputs.forEach((element) => {
			M.Datepicker.init(element, {
				// selectMonths: true,
				format: 'yyyy-mm-dd',
				// formatSubmit: 'yyyy-mm-dd',
				firstDay: 1,
			})
		})
	}

	const init = () => {
		setState({ ...getDatePickerComponents() })

		initDates()
	}

	return {
		init,
	}
})()
